import { forwardRef, useEffect, useState } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { Field } from "formik";

import LdsValidationError from "../LdsValidationError/index.jsx";

const LdsTextField = forwardRef(function LdsTextField(
  {
    id,
    name,
    label = "",
    labelRequired = false,
    labelClassName,
    ariaDescribedBy = "",
    disabled = false,
    error = false,
    errorMessage,
    hint,
    className,
    required,
    ...rest
  },
  ref
) {
  const [describedBy, setDescribedBy] = useState(ariaDescribedBy);
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;

  useEffect(() => {
    let desc = ariaDescribedBy;
    if (hint) desc += ` ${hintId}`;
    if (error && errorMessage) desc += ` ${errorId}`;

    setDescribedBy(desc.trim());
  }, [hint, hintId, ariaDescribedBy, error, errorMessage, errorId]);

  return (
    <>
      <label className={cn("lds-form-label", { disabled }, labelClassName)}>
        {label} {labelRequired && <span className="required">*</span>}
        {hint && (
          <div className="lds-form-hint-margin-bottom" aria-hidden="true">
            <span className="lds-form-hint" id={hintId}>
              {hint}
            </span>
          </div>
        )}
        <Field
          id={id}
          className={cn("lds-text-field", { disabled, error }, className)}
          type="text"
          name={name}
          aria-describedby={describedBy}
          disabled={disabled}
          aria-invalid={error || null}
          ref={ref}
          required={required}
          aria-required={required ? true : null}
          {...rest}
        />
      </label>
      {error && errorMessage && (
        <LdsValidationError id={errorId}>{errorMessage}</LdsValidationError>
      )}
    </>
  );
});

LdsTextField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  hint: PropTypes.string,
  required: PropTypes.bool,
};

export default LdsTextField;
